module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="modal-header">\n  <h3>Learn about Samaritan Basic</h3>\n</div>\n\n<div class="modal-content has-video">\n  <iframe src="https://player.vimeo.com/video/232680932?title=0&amp;badge=0&amp;portrait=0&amp;byline=0&amp;color=754d85&amp;autoplay=true" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>\n</div>\n\n<div class="modal-footer align-center">\n  <button data-id="close" class="button button--smooth button--blue">Finish watching video</button>\n</div>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="modal-header">\n  <h3>Learn about Samaritan Basic</h3>\n</div>\n\n<div class="modal-content has-video">\n  <iframe src="https://player.vimeo.com/video/232680932?title=0&amp;badge=0&amp;portrait=0&amp;byline=0&amp;color=754d85&amp;autoplay=true" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>\n</div>\n\n<div class="modal-footer align-center">\n  <button data-id="close" class="button button--smooth button--blue">Finish watching video</button>\n</div>\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// ./example/scripts/templates/modal_video.ejs
// module id = 18
// module chunks = 0